(() => {
  const inputSelector = '.swinger-stepper .swinger-input__input';
  const update = (elem) => {
    const input = elem.querySelector('.swinger-input__input');
    const buttonDelete = elem.querySelector('.swinger-button-delete');
    const buttonMinus = elem.querySelector('.swinger-stepper__button--minus');
    const buttonPlus = elem.querySelector('.swinger-stepper__button--plus');
    const value = parseInt(input.value, 10);
    const min = parseInt(input.min, 10) || 1;
    const max = parseInt(input.max, 10) || 99;

    if (buttonDelete) {
      buttonDelete.disabled = (Math.abs(value) > 1);
      buttonDelete[buttonDelete.disabled ? 'setAttribute' : 'removeAttribute']('aria-disabled', 'true');
    }

    if (buttonMinus) {
      buttonMinus.disabled = (value <= min);
      buttonMinus[buttonMinus.disabled ? 'setAttribute' : 'removeAttribute']('aria-disabled', 'true');
    }

    if (buttonPlus) {
      buttonPlus.disabled = (value >= max);
      buttonPlus[buttonPlus.disabled ? 'setAttribute' : 'removeAttribute']('aria-disabled', 'true');
    }
  };

  window.swinger.observer.initialize('.swinger-stepper', (elem) => {
    update(elem);
  });

  [
    'change',
    'programmatic-change',
  ].forEach((eventName) => {
    document.addEventListener(eventName, (e) => {
      const elem = window.swinger.eventHub.getTarget(e);

      if (!elem.matches(inputSelector)) {
        return;
      }

      const wrapper = elem.closest('.swinger-stepper');

      update(wrapper);
    });
  });

  document.addEventListener('click', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);

    if (!elem.matches('.swinger-stepper__button')) {
      return;
    }

    elem.removeAttribute('aria-hidden');

    const wrapper = elem.closest('.swinger-stepper');
    const input = wrapper.querySelector('.swinger-input__input');
    const value = parseInt(input.value, 10);
    const step = parseInt(input.step, 10) || 1;
    const max = parseInt(input.max, 10) || 99;
    let offset = 0;

    switch (true) {
      default:
        break;

      case elem.matches('.swinger-stepper__button--minus'):
        offset = -1;
        break;

      case elem.matches('.swinger-stepper__button--plus'):
        offset = 1;
        break;
    }

    window.swinger.eventHub.trigger(input, 'focus');

    input.value = Math.min(max, Math.max(0, value + (offset * step)));

    window.swinger.eventHub.trigger(input, 'input');
    window.swinger.eventHub.trigger(input, 'change');
    window.swinger.eventHub.trigger(input, 'blur');
  }, true);
})();
